export interface Photo {
  src: string;
  alt: string;
  title: string;
  tags: string[];
}

export const photoTags = [
  'Outside',
  'Animals',
  'Lake & dock',
  'Sunsets',
  'Northern lights',
  'Spring blossoms'
];

export const photos: Photo[] = [
  {
    src: '/images/gallery/01.jpg',
    title: 'Spring on Hotel Lake',
    alt: 'Pink cherry blossoms framing Hotel Lake and the forested shoreline',
    tags: ['Outside', 'Lake & dock', 'Spring blossoms']
  },
  {
    src: '/images/gallery/02.jpg',
    title: 'A place to slow down',
    alt: 'Picnic table and lakeside seating beside the dock and flowering cherry tree',
    tags: ['Outside', 'Lake & dock', 'Spring blossoms']
  },
  {
    src: '/images/gallery/04.jpg',
    title: 'Blossoms by the water',
    alt: 'Cherry blossoms over the lake beside the swimming ladder',
    tags: ['Outside', 'Lake & dock', 'Spring blossoms']
  },
  {
    src: '/images/gallery/sunset-on-the-dock.webp',
    title: 'The last light of the day',
    alt: 'A person standing on the dock beneath an orange sunset reflected in Hotel Lake',
    tags: ['Outside', 'Lake & dock', 'Sunsets']
  },
  {
    src: '/images/gallery/northern-lights.webp',
    title: 'A sky worth staying up for',
    alt: 'Green and purple northern lights above the silhouettes of evergreen trees',
    tags: ['Outside', 'Northern lights']
  },
  {
    src: '/images/gallery/sunset-over-hotel-lake.webp',
    title: 'Hotel Lake in pink',
    alt: 'A pink sunset reflected in the still water below forested hills',
    tags: ['Outside', 'Lake & dock', 'Sunsets']
  },
  {
    src: '/images/gallery/dock-and-cherry-tree.webp',
    title: 'Days by the dock',
    alt: 'The private dock and beach beside a cherry tree and lakeside gazebo',
    tags: ['Outside', 'Lake & dock', 'Spring blossoms']
  },
  {
    src: '/images/gallery/deer-by-the-cottage.webp',
    title: 'A woodland visitor',
    alt: 'A deer standing on a mossy rock in front of evergreen trees',
    tags: ['Animals']
  },
  {
    src: '/images/gallery/bald-eagle-on-hotel-lake.webp',
    title: 'An eagle by the lake',
    alt: 'A bald eagle perched on a log along the grassy edge of Hotel Lake',
    tags: ['Animals', 'Lake & dock']
  }
];

export const homePagePhotos = [...photos.slice(1), photos[0]];
const deerIndex = homePagePhotos.findIndex(
  (photo) => photo.src === '/images/gallery/deer-by-the-cottage.webp'
);
if (deerIndex !== -1) {
  const [deerPhoto] = homePagePhotos.splice(deerIndex, 1);
  homePagePhotos.splice(1, 0, deerPhoto);
}
[homePagePhotos[2], homePagePhotos[3]] = [homePagePhotos[3], homePagePhotos[2]];
